"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidderDocumentsTab = void 0;
var react_1 = __importDefault(require("react"));
var single_upload_1 = require("../../../controls/file/single_upload");
var doshx_controls_web_1 = require("doshx_controls_web");
var BidderDocumentsTab = function (props) {
    var bidder_entity_id = props.bidder_entity_id;
    return (react_1.default.createElement("div", { className: "flex flex-col w-full p-4" }, bidder_entity_id ? (react_1.default.createElement("div", { className: "flex flex-row gap-4" },
        react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Proof of Identification", size: "xlarge", bold: true })),
            react_1.default.createElement(single_upload_1.SingleUploadControl, { type: "Document", bidder_entity_id: bidder_entity_id, custom_name: "proof_of_id" })),
        react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Proof of Address", size: "xlarge", bold: true })),
            react_1.default.createElement(single_upload_1.SingleUploadControl, { type: "Document", bidder_entity_id: bidder_entity_id, custom_name: "proof_of_address" })))) : (react_1.default.createElement("div", { className: "flex flex-col space-y-4" }, "Something went wrong, please contact support."))));
};
exports.BidderDocumentsTab = BidderDocumentsTab;
